import './FormSteps.css';

export type FormStepDefinition = {
  id: number;
  title: string;
  shortTitle: string;
};

type FormStepsProps = {
  steps: FormStepDefinition[];
  currentStep: number;
  onStepClick?: (stepId: number) => void;
  allowNavigateToCompleted?: boolean;
};

export function FormSteps({
  steps,
  currentStep,
  onStepClick,
  allowNavigateToCompleted = false,
}: FormStepsProps) {
  const currentStepDef = steps[currentStep - 1];

  const handleStepClick = (stepId: number) => {
    if (!onStepClick || !allowNavigateToCompleted) return;
    if (stepId < currentStep) {
      onStepClick(stepId);
    }
  };

  return (
    <div className="form-steps">
      <div className="form-steps__track">
        {steps.map((step, index) => {
          const isActive = currentStep === step.id;
          const isCompleted = currentStep > step.id;
          const isLast = index === steps.length - 1;

          return (
            <div key={step.id} className="form-steps__item">
              <button
                type="button"
                className={[
                  'form-steps__circle',
                  isActive ? 'form-steps__circle--active' : '',
                  isCompleted ? 'form-steps__circle--completed' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
                onClick={() => handleStepClick(step.id)}
                disabled={!isCompleted || !allowNavigateToCompleted}
                aria-current={isActive ? 'step' : undefined}
                aria-label={`Etapa ${step.id}: ${step.title}`}
                title={step.title}
              >
                {isCompleted ? <i className="bi bi-check-lg" style={{ color: '#fff' }} /> : step.id}
              </button>
              {!isLast && (
                <div
                  className={[
                    'form-steps__line',
                    isCompleted ? 'form-steps__line--completed' : '',
                  ]
                    .filter(Boolean)
                    .join(' ')}
                />
              )}
            </div>
          );
        })}
      </div>

      {currentStepDef && (
        <div className="form-steps__banner">
          <p className="form-steps__banner-title">
            Etapa {currentStep} de {steps.length} – {currentStepDef.title}
          </p>
          <p className="form-steps__banner-subtitle">{currentStepDef.shortTitle}</p>
        </div>
      )}

      <div className="form-steps__labels">
        {steps.map((step) => {
          const isActive = currentStep === step.id;
          const isCompleted = currentStep > step.id;
          return (
            <span
              key={step.id}
              className={[
                'form-steps__label',
                isActive ? 'form-steps__label--active' : '',
                isCompleted ? 'form-steps__label--completed' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {step.title}
            </span>
          );
        })}
      </div>
    </div>
  );
}
